import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './law_firm_description.module.scss';
import { LawFirmContext } from '../LawFirmContext';

type Props = {
  hasExperience: boolean;
};

export const LawFirmDescription: FC<Props> = ({ hasExperience }) => {
  const {
    lawFirmInfos: { name },
    experience: { decisionCount },
  } = useContext(LawFirmContext);
  const doctrine = (
    <b>
      <FormattedMessage id="law-firm/page/description/LawFirmDescription.tsx/2" />
    </b>
  );

  const pageName = `le cabinet ${name}`;
  const nameStyled = <b>{pageName}</b>;
  const nameStyledEnd = <b>{`${pageName}.`}</b>;

  return (
    <>
      {decisionCount ? (
        <>
          <hr className={styles.separator} />
          <div className={styles.block}>
            <span className={styles.title}>
              <FormattedMessage id="law-firm/page/description/LawFirmDescription.tsx/1" />
            </span>
          </div>
          <div className={styles.item}>
            <FormattedMessage
              id="law-firm/page/description/LawFirmDescription.tsx/3"
              values={{
                doctrine,
                end: hasExperience ? (
                  <FormattedMessage
                    id="law-firm/page/description/LawFirmDescription.tsx/5"
                    values={{ name: nameStyled }}
                  />
                ) : (
                  nameStyledEnd
                ),
              }}
            />
          </div>
        </>
      ) : (
        <span className={styles.item}>
          <FormattedMessage
            id="law-firm/page/description/LawFirmDescription.tsx/4"
            values={{ doctrine, name: nameStyledEnd }}
          />
        </span>
      )}
    </>
  );
};
